import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Cart from "@/pages/Cart";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import Policy from "@/pages/Policy";

import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import Dashboard from "@/pages/admin/Dashboard";
import ProductForm from "@/pages/admin/ProductForm";

const Store = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Store><Home /></Store>} />
              <Route path="/shop" element={<Store><Shop /></Store>} />
              <Route path="/category/:slug" element={<Store><Shop /></Store>} />
              <Route path="/product/:id" element={<Store><ProductDetail /></Store>} />
              <Route path="/cart" element={<Store><Cart /></Store>} />
              <Route path="/checkout/success" element={<Store><CheckoutSuccess /></Store>} />
              <Route path="/policy/:type" element={<Store><Policy /></Store>} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/admin/products/new" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
              <Route path="/admin/products/:id/edit" element={<ProtectedRoute><ProductForm /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
